require('./modal.js');

Pegasus.OceansHandoffModal = Pegasus.Modal.extend({
  title: Pegasus.computed.t('modals.free_account_title'),
  contextMessaging: '',
  width: '500px',
  classNames: ['editor-handoff-modal'],
  headerClassName: 'editor-modal-header',
  bodyClassName: 'editor-modal-body',
  bodyTemplateName: 'modals/oceans_handoff',
  hasFooter: false,
  frameSource: function(){
    return Pegasus.handoffHost();
  }.property(),

  cancelCallback: null,

  didCancel: function(){
    var callback = this.get('presenter.cancelCallback');
    if ( callback ) {
      callback();
    }
    this.set('controller.presenter', null);
  }
});
